import Inbox from "@mui/icons-material/Inbox";
import { Typography } from "@mui/material";
import { CreateButton } from "react-admin";
import { UploadDocumentsConstants as UDC } from "../utils/const";

export const CustomEmpty = () => (
  <div style={{ textAlign: "center", width: "100%" }}>
    <div
      style={{
        textAlign: "center",
        opacity: 0.5,
        margin: "0 1em",
        color: "inherit",
      }}
    >
      <Inbox style={{ width: "9em", height: "9em" }} />
      <Typography variant="h4" paragraph>
        Загруженных документов нет
      </Typography>
      <Typography variant="body1">
        Вы можете загрузить документ, нажав на кнопку
      </Typography>
    </div>
    <div style={{ textAlign: "center", marginTop: "2em" }}>
      <CreateButton label={UDC.createButtonLabel} variant="contained" />
    </div>
  </div>
);
